// title  标题
// tabbar 底部导航栏
// unpull: true 禁用下拉刷新
// unback: true, 不展示返回顶部按钮
// noheader：true 没有顶部
export default [
  {
    path: "user/center",
    name: "user.center",
    meta: {
      title: "个人中心",
      tabbar: true,
      unback: true,
      noheader: true,
    },
    component: () => import("./UserCenter"),
  },
  {
    path: "user/setting",
    name: "user.setting",
    meta: {
      title: "系统设置",
      unpull: true,
      noheader: true, //没有顶部
    },
    component: () => import("./UserSetting"),
  },
  {
    path: "user/exchange",
    name: "user.exchange",
    meta: {
      title: "兑换手机",
      unpull: true,
      noheader: true, //没有顶部
    },
    component: () => import("./Exchange.vue"),
  },
  {
    path: "select/device",
    name: "select.device",
    meta: {
      title: "选择设备",
      unpull: true,
      noheader: true, //没有顶部
    },
    component: () => import("./ExchangeSelectDevice.vue"),
  },
  {
    path: "exchange/history",
    name: "exchange.history",
    meta: {
      title: "历史兑换",
      unpull: true,
      noheader: true, //没有顶部
    },
    component: () => import("./ExchangeHistory.vue"),
  },
  {
    path: "device/manage",
    name: "device.manage",
    meta: {
      title: "设备管理",
      unpull: true,
      noheader: true, //没有顶部
    },
    component: () => import("./DeviceManage"),
  },
  {
    path: "user/accountbind",
    name: "user.accountbind",
    meta: {
      title: "账号绑定",
      unpull: true,
      noheader: true, //没有顶部
    },
    component: () => import("./AccountBind"),
  },
  {
    path: "user/mobliebind",
    name: "user.mobliebind",
    meta: {
      title: "绑定手机号",
      unpull: true,
      noheader: true, //没有顶部
    },
    component: () => import("./MobileBind"),
  },
  {
    path: "user/modifycode",
    name: "user.modifycode",
    meta: {
      title: "安全验证",
      unpull: true,
      noheader: true, //没有顶部
    },
    component: () => import("./CodeSafeVerify.vue"),
  },
  {
    path: "user/codemodify",
    name: "user.codemodify",
    meta: {
      title: "修改密码",
      unpull: true,
      noheader: true, //没有顶部
    },
    component: () => import("./CodeModify.vue"),
  },
  {
    path: "user/setpassword",
    name: "user.setpassword",
    meta: {
      title: "设置密码",
      unpull: true,
      noheader: true,
    },
    component: () => import("./SetPassword.vue"),
  },
  {
    path: "user/switchAccount",
    name: "user.switchAccount",
    meta: {
      title: "切换账号",
      unpull: true,
      noheader: true,
    },
    component: () => import("./SwitchAccount.vue"),
  },

  {
    path: "user/about",
    name: "user.about",
    meta: {
      title: "关于我们",
      unpull: true,
      noheader: true, //没有顶部
    },
    component: () => import("./About"),
  },
  {
    path: "user/policefile",
    name: "user.policefile",
    meta: {
      title: "协议政策",
      unpull: true,
      noheader: true, //没有顶部
    },
    component: () => import("./PoliceFile.vue"),
  },
  {
    path: "user/cancelAccount",
    name: "user.cancelAccount",
    meta: {
      title: "注销账号",
      unpull: true,
      noheader: true, //没有顶部
    },
    component: () => import("./cancelAccount"),
  },
  {
    path: "user/identity",
    name: "user.identity",
    meta: {
      title: "实名认证",
      unpull: true,
      noheader: true, //没有顶部
    },
    component: () => import("./UserIdentity"),
  },
  {
    path: "user/customerservice",
    name: "user.customerservice",
    meta: {
      title: "实名认证",
      unpull: true,
      noheader: true, //没有顶部
    },
    component: () => import("./Customerservice"),
  },
  {
    path: "user/edit",
    name: "user.edit",
    meta: {
      title: "编辑资料",
      unpull: true,
      // tabbar: true,
      // unback: true,
      // noheader: true
      noheader: true, //没有顶部
    },
    component: () => import("./UserEdit"),
  },
  {
    path: "user/accountInstructions",
    name: "user.accountInstructions",
    meta: {
      title: "申请注销",
      unpull: true,
    },
    component: () => import("./accountInstructions.vue"),
  },
  {
    path: "user/message",
    name: "user.message",
    meta: {
      title: "消息",
      noheader: true,
      unpull: true,
    },
    component: () => import("./userMessage.vue"),
  },
  {
    path: "user/messagedetail",
    name: "user.messagedetail",
    meta: {
      title: "消息详情",
    },
    component: () => import("./userMessageDetail.vue"),
  },
  {
    path: "loginDevice/list",
    name: "loginDevice.list",
    meta: {
      title: "登录设备管理",
      unpull: true,
      noheader: true,
    },
    component: () => import("./LoginDeviceList.vue"),
  },
  {
    path: "loginDevice/detail",
    name: "loginDevice.detail",
    meta: {
      title: "设备详情",
      unpull: true,
      noheader: true,
    },
    component: () => import("./LoginDeviceDetail.vue"),
  },
  {
    path: "user/WechatWarn",
    name: "user.weChatWarn",
    meta: {
      title: "微信提醒",
      unpull: true,
      noheader: true,
    },
    component: () => import("./WechatWarn.vue"),
  },
  {
    path: "user/networkCheck",
    name: "user.networkCheck",
    meta: {
      title: "微信提醒",
      unpull: true,
      noheader: true,
    },
    component: () => import("./NetworkCheck.vue"),
  },
  {
    path: "user/selDevCheck",
    name: "user.selDevCheck",
    meta: {
      title: "微信提醒",
      unpull: true,
      noheader: true,
    },
    component: () => import("./selCheckDevice.vue"),
  },
];
